export default __webpack_public_path__ + "static/lizMartin1-5568b2fc6bbc89dfa4a5642f4c103e7b.svg";